import serverCall from "../../serverCall";

const uploadFile = (body, targetLanguage) => {
  try {
    const response = serverCall.post(
      `/ai-conversation/pdf?targetLanguage=${targetLanguage}`,
      body
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const status = (body) => {
  try {
    const response = serverCall.post(`/ai-conversation/status`, body);
    return response;
  } catch (error) {
    throw error;
  }
};

const result = (body) => {
  try {
    const response = serverCall.post(`/ai-conversation/results`, body);
    return response;
  } catch (error) {
    throw error;
  }
};

const UploadService = {
  uploadFile,
  status,
  result,
};

export default UploadService;
